"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomStatus = void 0;
var room_login_1 = require("./room-login");
var room_heart_beat_1 = require("./room-heart-beat");
var util_1 = require("../util");
var room_channel_define_1 = require("./room-channel-define");
var RoomStatus = /** @class */ (function () {
    function RoomStatus(msgSender, channelOption, connectionControllerDependency) {
        this.roomState = room_channel_define_1.RoomState.INIT;
        this.channelOption = channelOption;
        this.connectionControllerDependency = connectionControllerDependency;
        this.messageSender = msgSender;
        this.roomLogin = new room_login_1.RoomLogin(msgSender, channelOption, this);
        this.roomHeartBeat = new room_heart_beat_1.RoomHeartBeat(msgSender, this.channelOption, this);
    }
    Object.defineProperty(RoomStatus.prototype, "state", {
        get: function () {
            return this.roomState;
        },
        enumerable: false,
        configurable: true
    });
    RoomStatus.prototype.dispose = function () {
        this.roomState = room_channel_define_1.RoomState.INIT;
        this.roomHeartBeat.dispose();
        this.roomLogin.dispose();
    };
    RoomStatus.prototype.openRoom = function () {
        if (!this.checkRoomState())
            return;
        this.messageSender.openWebsocketConnection();
        if (this.roomState === room_channel_define_1.RoomState.INIT) {
            this.setRoomState(room_channel_define_1.RoomState.CONNECTING);
        }
        else {
            this.setRoomState(room_channel_define_1.RoomState.RECONNECTING_IN_CLOSED);
        }
    };
    RoomStatus.prototype.onRoomClosed = function (closeReason) {
        if (closeReason.shutDown) {
            this.handleShutDown(closeReason);
        }
        else {
            this.handleRoomClose(closeReason);
        }
    };
    RoomStatus.prototype.loginRoom = function () {
        this.roomLogin.login();
    };
    RoomStatus.prototype.resetLogin = function () {
        this.roomLogin.resetLogin();
    };
    RoomStatus.prototype.onLoginResponse = function (head, body) {
        this.roomLogin.onLoginResponse(head, body);
    };
    RoomStatus.prototype.resetHeartBeat = function () {
        this.roomHeartBeat.resetHeartBeat();
    };
    RoomStatus.prototype.onHeartBeatResponse = function (head, body) {
        this.roomHeartBeat.onHeartBeatResponse(head, body);
    };
    RoomStatus.prototype.roomStateReconnecting = function () {
        this.setRoomState(room_channel_define_1.RoomState.CONNECTING);
    };
    /* IRoomStatusDependency begin */
    RoomStatus.prototype.getRoomState = function () {
        return this.state;
    };
    RoomStatus.prototype.notifyRoomOpened = function (result) {
        this.setRoomState(room_channel_define_1.RoomState.OPENED);
        this.resetLogin();
        this.roomHeartBeat.resetHeartBeat();
        var response = result.response;
        this.roomHeartBeat.startHeartBeatOnTimer(response.onpost.heartbeat_interval);
        // 消息队列继续执行
        this.messageSender.startMessageSending();
        this.messageSender.notifyRoomOpened();
        this.connectionControllerDependency.connected();
    };
    /* IRoomStatusDependency end */
    RoomStatus.prototype.checkRoomState = function () {
        if (this.state === room_channel_define_1.RoomState.OPENED || this.state === room_channel_define_1.RoomState.SHUTDOWN) {
            util_1.ConnectionLog.warn("checkRoomState:state is " + this.state + "!");
            return false;
        }
        return true;
    };
    RoomStatus.prototype.setRoomState = function (newState, reason) {
        if (reason === void 0) { reason = ''; }
        if (newState !== this.roomState) {
            this.roomState = newState;
            util_1.ConnectionLog.info("setRoomState:set new state = " + newState);
            this.connectionControllerDependency.connectedStateChange(this.roomState, reason);
        }
    };
    RoomStatus.prototype.handleShutDown = function (closeReason) {
        var oldState = this.roomState;
        this.setRoomState(room_channel_define_1.RoomState.SHUTDOWN, closeReason.reason);
        if (oldState !== room_channel_define_1.RoomState.SHUTDOWN) {
            this.connectionControllerDependency.disconnect(closeReason);
        }
    };
    RoomStatus.prototype.handleRoomClose = function (closeReason) {
        var oldState = this.roomState;
        this.setRoomState(room_channel_define_1.RoomState.RECONNECTING_IN_CLOSED, closeReason.reason);
        if (oldState !== room_channel_define_1.RoomState.RECONNECTING_IN_CLOSED) {
            this.connectionControllerDependency.disconnect(closeReason);
        }
    };
    RoomStatus.prototype.heartBeatCommon = function (heartBeatCommon) {
        var _a, _b;
        (_b = (_a = this.connectionControllerDependency).heartBeatCommon) === null || _b === void 0 ? void 0 : _b.call(_a, heartBeatCommon);
    };
    return RoomStatus;
}());
exports.RoomStatus = RoomStatus;
